import { useState } from 'react';
import type { MonthGridCell, MonthPickerMonth } from '../types/calendar';

type Grid = Record<number, Record<number, MonthGridCell>>;

const isSelected = (selectedMonths: MonthPickerMonth[], month: number, year: number): boolean =>
    selectedMonths.some((m) => m.month === month && m.year === year);

export const useMonthGrid = (firstYear: number, firstMonth: number, totalMonths: number, selectedMonths: MonthPickerMonth[]) => {
    const createGrid = (): Grid => {
        const grid: Grid = {};
        let monthsLeft = totalMonths;
        let year = firstYear;
        let month = firstMonth;

        while (monthsLeft > 0) {
            const monthsThisYear = Math.min(12 - month, monthsLeft);
            const row: Record<number, MonthGridCell> = {};

            for (let i = 0; i < monthsThisYear; i++) {
                const monthNumber = i + month + 1;
                row[monthNumber] = {
                    year,
                    month: monthNumber,
                    selected: isSelected(selectedMonths, monthNumber, year),
                };
            }

            grid[year] = row;
            monthsLeft -= monthsThisYear;
            month = 0;
            year++;
        }

        return grid;
    };

    const [grid, setGrid] = useState(createGrid);

    const toggle = (cell: MonthGridCell) => {
        const { year, month } = cell;
        setGrid((prev) => ({
            ...prev,
            [year]: {
                ...prev[year],
                [month]: {
                    ...prev[year][month],
                    selected: !cell.selected,
                },
            },
        }));
    };

    return { grid, toggle };
};
